import * as actionTypes from '../constants/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  controlConfig: null,
  controlConfigError: null,
  controlConfigLoading: false,
  saveControlConfigResult: null,
  saveControlConfigError: null,
  saveControlConfigLoading: false,
  notes: null,
  error: null,
  loading: false,
  notesFileAssociations: null,
  notesFileAssociationsError: null,
  notesFileAssociationsLoading: false,
  truckingCompanies: null,
  truckingCompaniesError: null,
  truckingCompaniesLoading: false,
  createNoteResult: null,
  createNoteError: null,
  createNoteLoading: false,
  assignNoteToTaskResult: null,
  assignNoteToTaskError: null,
  assignNoteToTaskLoading: false,
  createNoteCommentError: null,
  createNoteCommentLoading: false,
  archiveNoteError: null,
  archiveNoteLoading: false,
  toggleNotePinError: null,
  toggleNotePinLoading: false,
  reassignNoteError: null,
  reassignNoteLoading: false,
  addNoteModalOpened: false,
  updateNoteResult: null,
  updateNoteError: null,
  updateNoteLoading: false,
};

const getNotesControlConfigStart = (state, action) => {
  return updateObject(state, {
    controlConfigError: null,
    controlConfigLoading: true,
  });
};

const getNotesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    controlConfig: action.controlConfig,
    controlConfigError: null,
    controlConfigLoading: false,
  });
};

const getNotesControlConfigFail = (state, action) => {
  return updateObject(state, {
    controlConfig: null,
    controlConfigError: action.error,
    controlConfigLoading: false,
  });
};

const saveNotesControlConfigStart = (state, action) => {
  return updateObject(state, {
    saveControlConfigError: null,
    saveControlConfigLoading: true,
  });
};

const saveNotesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    saveControlConfigResult: action.saveControlConfigResult,
    saveControlConfigError: null,
    saveControlConfigLoading: false,
  });
};

const saveNotesControlConfigFail = (state, action) => {
  return updateObject(state, {
    saveControlConfigResult: null,
    saveControlConfigError: action.error,
    saveControlConfigLoading: false,
  });
};

const getNotesStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const getNotesSuccess = (state, action) => {
  return updateObject(state, {
    notes: action.notes,
    error: null,
    loading: false,
  });
};

const getNotesFail = (state, action) => {
  return updateObject(state, {
    notes: null,
    error: action.error,
    loading: false,
  });
};

const getNotesFileAssociationsStart = (state, action) => {
  return updateObject(state, {
    notesFileAssociationsError: null,
    notesFileAssociationsLoading: true,
  });
};

const getNotesFileAssociationsSuccess = (state, action) => {
  return updateObject(state, {
    notesFileAssociations: action.notesFileAssociations,
    notesFileAssociationsError: null,
    notesFileAssociationsLoading: false,
  });
};

const getNotesFileAssociationsFail = (state, action) => {
  return updateObject(state, {
    notesFileAssociations: null,
    notesFileAssociationsError: action.error,
    notesFileAssociationsLoading: false,
  });
};

const clearNotesStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const clearNotesSuccess = (state, action) => {
  return updateObject(state, {
    notes: action.notes,
    error: null,
    loading: false,
  });
};

const getAllTruckingCompaniesStart = (state, action) => {
  return updateObject(state, {
    truckingCompaniesError: null,
    truckingCompaniesLoading: true,
  });
};

const getAllTruckingCompaniesSuccess = (state, action) => {
  return updateObject(state, {
    truckingCompanies: action.truckingCompanies,
    truckingCompaniesError: null,
    truckingCompaniesLoading: false,
  });
};

const getAllTruckingCompaniesFail = (state, action) => {
  return updateObject(state, {
    truckingCompanies: null,
    truckingCompaniesError: action.error,
    truckingCompaniesLoading: false,
  });
};

const createNoteStart = (state, action) => {
  return updateObject(state, {
    createNoteResult: null,
    createNoteError: null,
    createNoteLoading: true,
  });
};

const createNoteSuccess = (state, action) => {
  return updateObject(state, {
    createNoteResult: action.data,
    createNoteError: null,
    createNoteLoading: false,
  });
};

const createNoteFail = (state, action) => {
  return updateObject(state, {
    createNoteResult: null,
    createNoteError: action.error,
    createNoteLoading: false,
  });
};

const assignNoteToTaskStart = (state, action) => {
  return updateObject(state, {
    assignNoteToTaskResult: null,
    assignNoteToTaskError: null,
    assignNoteToTaskLoading: true,
  });
};

const assignNoteToTaskSuccess = (state, action) => {
  return updateObject(state, {
    assignNoteToTaskResult: action.data,
    assignNoteToTaskError: null,
    assignNoteToTaskLoading: false,
  });
};

const assignNoteToTaskFail = (state, action) => {
  return updateObject(state, {
    assignNoteToTaskResult: null,
    assignNoteToTaskError: action.error,
    assignNoteToTaskLoading: false,
  });
};

const createNoteCommentStart = (state, action) => {
  return updateObject(state, {
    createNoteCommentError: null,
    createNoteCommentLoading: true,
  });
};

const createNoteCommentSuccess = (state, action) => {
  return updateObject(state, {
    createNoteCommentError: null,
    createNoteCommentLoading: false,
  });
};

const createNoteCommentFail = (state, action) => {
  return updateObject(state, {
    createNoteCommentError: action.error,
    createNoteCommentLoading: false,
  });
};

const archiveNoteStart = (state, action) => {
  return updateObject(state, {
    archiveNoteError: null,
    archiveNoteLoading: true,
  });
};

const archiveNoteSuccess = (state, action) => {
  return updateObject(state, {
    archiveNoteError: null,
    archiveNoteLoading: false,
  });
};

const archiveNoteFail = (state, action) => {
  return updateObject(state, {
    archiveNoteError: action.error,
    archiveNoteLoading: false,
  });
};

const toggleNotePinStart = (state, action) => {
  return updateObject(state, {
    toggleNotePinError: null,
    toggleNotePinLoading: true,
  });
};

const toggleNotePinSuccess = (state, action) => {
  return updateObject(state, {
    toggleNotePinError: null,
    toggleNotePinLoading: false,
  });
};

const toggleNotePinFail = (state, action) => {
  return updateObject(state, {
    toggleNotePinError: action.error,
    toggleNotePinLoading: false,
  });
};

const reassignNoteStart = (state, action) => {
  return updateObject(state, {
    reassignNoteError: null,
    reassignNoteLoading: true,
  });
};

const reassignNoteSuccess = (state, action) => {
  return updateObject(state, {
    reassignNoteError: null,
    reassignNoteLoading: false,
  });
};

const reassignNoteFail = (state, action) => {
  return updateObject(state, {
    reassignNoteError: action.error,
    reassignNoteLoading: false,
  });
};

const exportNotesToPdfStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const exportNotesToPdfSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const exportNotesToPdfFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const exportNotesToExcelStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const exportNotesToExcelSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const exportNotesToExcelFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const addNoteModalStateChangeSuccess = (state, action) => {
  return updateObject(state, {
    addNoteModalOpened: action.opened,
  });
};

const updateNoteStart = (state, action) => {
  return updateObject(state, {
    updateNoteResult: null,
    updateNoteError: null,
    updateNoteLoading: true,
  });
};

const updateNoteSuccess = (state, action) => {
  return updateObject(state, {
    updateNoteResult: action.data,
    updateNoteError: null,
    updateNoteLoading: false,
  });
};

const updateNoteFail = (state, action) => {
  return updateObject(state, {
    updateNoteResult: null,
    updateNoteError: action.error,
    updateNoteLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_NOTES_CONTROL_CONFIG_START:
      return getNotesControlConfigStart(state, action);
    case actionTypes.GET_NOTES_CONTROL_CONFIG_SUCCESS:
      return getNotesControlConfigSuccess(state, action);
    case actionTypes.GET_NOTES_CONTROL_CONFIG_FAIL:
      return getNotesControlConfigFail(state, action);

    case actionTypes.SAVE_NOTES_CONTROL_CONFIG_START:
      return saveNotesControlConfigStart(state, action);
    case actionTypes.SAVE_NOTES_CONTROL_CONFIG_SUCCESS:
      return saveNotesControlConfigSuccess(state, action);
    case actionTypes.SAVE_NOTES_CONTROL_CONFIG_FAIL:
      return saveNotesControlConfigFail(state, action);

    case actionTypes.GET_NOTES_START:
      return getNotesStart(state, action);
    case actionTypes.GET_NOTES_SUCCESS:
      return getNotesSuccess(state, action);
    case actionTypes.GET_NOTES_FAIL:
      return getNotesFail(state, action);

    case actionTypes.GET_NOTES_FILE_ASSOCIATIONS_START:
      return getNotesFileAssociationsStart(state, action);
    case actionTypes.GET_NOTES_FILE_ASSOCIATIONS_SUCCESS:
      return getNotesFileAssociationsSuccess(state, action);
    case actionTypes.GET_NOTES_FILE_ASSOCIATIONS_FAIL:
      return getNotesFileAssociationsFail(state, action);

    case actionTypes.CLEAR_NOTES_START:
      return clearNotesStart(state, action);
    case actionTypes.CLEAR_NOTES_SUCCESS:
      return clearNotesSuccess(state, action);

    case actionTypes.GET_ALL_TRUCKING_COMPANIES_START:
      return getAllTruckingCompaniesStart(state, action);
    case actionTypes.GET_ALL_TRUCKING_COMPANIES_SUCCESS:
      return getAllTruckingCompaniesSuccess(state, action);
    case actionTypes.GET_ALL_TRUCKING_COMPANIES_FAIL:
      return getAllTruckingCompaniesFail(state, action);

    case actionTypes.CREATE_NOTE_START:
      return createNoteStart(state, action);
    case actionTypes.CREATE_NOTE_SUCCESS:
      return createNoteSuccess(state, action);
    case actionTypes.CREATE_NOTE_FAIL:
      return createNoteFail(state, action);

    case actionTypes.ASSIGN_NOTE_TO_TASK_START:
      return assignNoteToTaskStart(state, action);
    case actionTypes.ASSIGN_NOTE_TO_TASK_SUCCESS:
      return assignNoteToTaskSuccess(state, action);
    case actionTypes.ASSIGN_NOTE_TO_TASK_FAIL:
      return assignNoteToTaskFail(state, action);

    case actionTypes.CREATE_NOTE_COMMENT_START:
      return createNoteCommentStart(state, action);
    case actionTypes.CREATE_NOTE_COMMENT_SUCCESS:
      return createNoteCommentSuccess(state, action);
    case actionTypes.CREATE_NOTE_COMMENT_FAIL:
      return createNoteCommentFail(state, action);

    case actionTypes.ARCHIVE_NOTE_START:
      return archiveNoteStart(state, action);
    case actionTypes.ARCHIVE_NOTE_SUCCESS:
      return archiveNoteSuccess(state, action);
    case actionTypes.ARCHIVE_NOTE_FAIL:
      return archiveNoteFail(state, action);

    case actionTypes.TOGGLE_NOTE_PIN_START:
      return toggleNotePinStart(state, action);
    case actionTypes.TOGGLE_NOTE_PIN_SUCCESS:
      return toggleNotePinSuccess(state, action);
    case actionTypes.TOGGLE_NOTE_PIN_FAIL:
      return toggleNotePinFail(state, action);

    case actionTypes.REASSIGN_NOTE_START:
      return reassignNoteStart(state, action);
    case actionTypes.REASSIGN_NOTE_SUCCESS:
      return reassignNoteSuccess(state, action);
    case actionTypes.REASSIGN_NOTE_FAIL:
      return reassignNoteFail(state, action);

    case actionTypes.EXPORT_NOTES_TO_PDF_START:
      return exportNotesToPdfStart(state, action);
    case actionTypes.EXPORT_NOTES_TO_PDF_SUCCESS:
      return exportNotesToPdfSuccess(state, action);
    case actionTypes.EXPORT_NOTES_TO_PDF_FAIL:
      return exportNotesToPdfFail(state, action);

    case actionTypes.EXPORT_NOTES_TO_EXCEL_START:
      return exportNotesToExcelStart(state, action);
    case actionTypes.EXPORT_NOTES_TO_EXCEL_SUCCESS:
      return exportNotesToExcelSuccess(state, action);
    case actionTypes.EXPORT_NOTES_TO_EXCEL_FAIL:
      return exportNotesToExcelFail(state, action);

    // App Internal state management
    case actionTypes.ADD_NOTE_MODAL_STATE_CHANGE:
      return addNoteModalStateChangeSuccess(state, action);

    case actionTypes.UPDATE_NOTE_START:
      return updateNoteStart(state, action);
    case actionTypes.UPDATE_NOTE_SUCCESS:
      return updateNoteSuccess(state, action);
    case actionTypes.UPDATE_NOTE_FAIL:
      return updateNoteFail(state, action);

    default:
      return state;
  }
};

export default reducer;
